(function () {
  if (window.CityScrollStoryRuntime) { window.CityScrollStoryRuntime.initAll(); return; }
  const selector = '[data-city-scroll-story]';
  const instances = new WeakMap();
  const clamp = (n, a = 0, b = 1) => Math.min(b, Math.max(a, n));
  const number = (value, fallback) => Number.isFinite(parseFloat(value)) ? parseFloat(value) : fallback;
  function create(section) {
    const stage = section.querySelector('[data-story-stage]');
    const videos = Array.from(section.querySelectorAll('video'));
    const scenes = Array.from(section.querySelectorAll('[data-story-scene]'));
    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const progressBar = section.querySelector('[data-story-progress]');
    const hint = section.querySelector('.city-scroll-story__hint');
    const counter = section.querySelector('[data-story-counter]');
    let video, duration = 1, narrative = 1, frame = 0, displayed = 0, target = 0, previous = 0, destroyed = false, near = false;
    let selectedScene = null, decodedTime = 0, lastSeek = 0;
    const primed = new WeakSet();
    const cleanups = [];
    const listen = (el, event, fn, options) => { el.addEventListener(event, fn, options); cleanups.push(() => el.removeEventListener(event, fn, options)); };
    const deviceMatches = scene => scene.dataset.device === 'both' || scene.dataset.device === (mobile.matches ? 'mobile' : 'desktop');
    const enhanced = () => !reduced.matches && video && !video.error;
    const ease = n => { n = clamp(n); return n * n * (3 - 2 * n); };
    function showScenes(time) {
      for (const scene of scenes) {
        const start = number(scene.dataset.start, 0);
        const finish = Math.max(start + 0.1, number(scene.dataset.end, start + 1));
        if (mobile.matches && scene.classList.contains('city-scroll-story__scene--product')) {
          const travel = scene.dataset.mobileMotion === 'true' && enhanced() ? ease((time - start) / (finish - start)) : 0;
          const x = number(scene.dataset.mobileX, 50);
          const y = number(scene.dataset.mobileY, 68);
          scene.style.setProperty('--scene-mobile-x', (x + (number(scene.dataset.mobileEndX, x) - x) * travel) + '%');
          scene.style.setProperty('--scene-mobile-y', (y + (number(scene.dataset.mobileEndY, y) - y) * travel) + '%');
        }
        const fade = Math.min(0.55, (finish - start) * 0.2);
        let opacity = !enhanced() ? 1 : ease((time - start) / fade) * (finish >= narrative ? 1 : ease((finish - time) / fade));
        if (start === 0 && time <= fade) opacity = 1;
        if (scene === selectedScene) opacity = 1;
        if (!deviceMatches(scene)) opacity = 0;
        const active = opacity > 0.08;
        scene.inert = !active;
        scene.setAttribute('aria-hidden', String(!active));
        scene.classList.toggle('is-active', active);
        const inner = scene.querySelector('[data-scene-inner]');
        inner.style.opacity = opacity.toFixed(3);
        inner.style.transform = enhanced() ? 'translateY(' + ((1 - opacity) * 14).toFixed(2) + 'px) scale(' + (0.98 + opacity * 0.02).toFixed(3) + ')' : 'none';
        inner.style.filter = 'none';
      }
    }
    function layout() {
      const height = stage.getBoundingClientRect().height || window.innerHeight;
      const multiplier = number(mobile.matches ? section.dataset.scrollMultiplierMobile : section.dataset.scrollMultiplier, 4);
      section.classList.toggle('is-enhanced', Boolean(enhanced()));
      section.classList.toggle('is-video-ready', Boolean(video && video.readyState >= 2 && !video.error));
      section.classList.toggle('has-mobile-video', Boolean(section.querySelector('.city-scroll-story__video--mobile')));
      section.style.height = enhanced() ? Math.round(height * (multiplier + 1)) + 'px' : '';
      showScenes(displayed * narrative);
      schedule();
    }
    function seek(now) {
      if (!enhanced() || video.readyState < 2 || video.seeking || (mobile.matches && now - lastSeek < 33)) return;
      const time = clamp(displayed * duration, 0, duration);
      if (Math.abs(video.currentTime - time) > 0.025) {
        try { lastSeek = now; video.currentTime = time; } catch (_) { return; }
      }
    }
    function render(now) {
      frame = 0;
      if (destroyed) return;
      if (enhanced()) {
        const distance = section.offsetHeight - stage.offsetHeight;
        target = clamp(-section.getBoundingClientRect().top / Math.max(1, distance));
        const delta = Math.min(64, previous ? now - previous : 16.67);
        const smoothing = clamp(number(section.dataset.smoothing, 0.12), 0.04, 0.24);
        displayed += (target - displayed) * (1 - Math.pow(1 - smoothing, delta / 16.67));
        if (Math.abs(target - displayed) < 0.0003) displayed = target;
        seek(now);
        const decoded = clamp(decodedTime / duration);
        showScenes(decoded * narrative);
        progressBar.style.transform = 'scaleX(' + displayed.toFixed(4) + ')';
        counter.textContent = Math.round(displayed * 100) + '%';
        section.classList.toggle('is-start', target < 0.025);
        hint.hidden = target >= 0.025;
        if (near && Math.abs(target - displayed) > 0.0003) schedule();
      } else showScenes(0);
      previous = now;
    }
    function schedule() { if (!frame && !destroyed) frame = requestAnimationFrame(render); }
    function selectVideo() {
      const next = mobile.matches ? section.querySelector('.city-scroll-story__video--mobile') || videos[0] : videos[0];
      if (video !== next) { decodedTime = next ? next.currentTime : 0; lastSeek = 0; }
      video = next;
      narrative = Math.max(1, number(mobile.matches ? section.dataset.durationMobile : section.dataset.duration, 24));
      for (const item of videos) {
        item.pause(); item.muted = true; item.defaultMuted = true; item.playsInline = true;
        item.preload = item === video && !reduced.matches ? 'auto' : 'none';
        item.classList.toggle('is-active', item === video);
      }
      duration = video && Number.isFinite(video.duration) ? Math.max(0.1, Math.min(video.duration - 0.04, narrative)) : narrative;
      if (video && near && !reduced.matches) video.preload = 'auto';
      layout();
    }
    videos.forEach(item => {
      listen(item, 'loadedmetadata', selectVideo);
      listen(item, 'durationchange', selectVideo);
      listen(item, 'loadeddata', () => { if (item === video) { decodedTime = item.currentTime; layout(); } });
      listen(item, 'seeked', () => { if (item === video) { decodedTime = item.currentTime; schedule(); } });
      listen(item, 'error', layout);
    });
    function primeVideo() {
      const active = video;
      if (!enhanced() || primed.has(active)) return;
      primed.add(active);
      const playback = active.play();
      if (playback && playback.then) playback.then(() => {
        active.pause();
        if (!destroyed && active === video) { lastSeek = 0; schedule(); }
      }).catch(() => { primed.delete(active); });
    }
    listen(section, 'touchstart', primeVideo, { passive: true });
    listen(section, 'pointerdown', primeVideo, { passive: true });
    listen(window, 'scroll', () => { selectedScene = null; schedule(); }, { passive: true });
    listen(window, 'resize', layout, { passive: true });
    listen(mobile, 'change', selectVideo);
    listen(reduced, 'change', selectVideo);
    const observer = new IntersectionObserver(entries => {
      near = entries[0].isIntersecting;
      if (near && video && !reduced.matches) video.preload = 'auto';
      if (near) schedule();
    }, { rootMargin: '50% 0px' });
    observer.observe(section);
    selectVideo();
    return {
      focusScene(scene) {
        if (!scene || !deviceMatches(scene)) return;
        if (enhanced()) {
          const mid = clamp((number(scene.dataset.start, 0) + number(scene.dataset.end, 1)) / 2 / narrative);
          window.scrollTo({ top: window.scrollY + section.getBoundingClientRect().top + mid * (section.offsetHeight - stage.offsetHeight), behavior: 'auto' });
          displayed = mid;
        } else scene.scrollIntoView({ block: 'center' });
        selectedScene = scene; showScenes(displayed * narrative); schedule();
      },
      destroy() {
        destroyed = true; cancelAnimationFrame(frame); observer.disconnect(); cleanups.forEach(fn => fn());
        section.classList.remove('is-enhanced', 'is-video-ready', 'has-mobile-video'); section.style.height = '';
        scenes.forEach(scene => { scene.inert = false; scene.removeAttribute('aria-hidden'); const inner = scene.querySelector('[data-scene-inner]'); inner.removeAttribute('style'); });
        instances.delete(section);
      }
    };
  }
  function init(section) { if (section && !instances.has(section)) instances.set(section, create(section)); }
  function initAll(root = document) { root.querySelectorAll(selector).forEach(init); }
  window.CityScrollStoryRuntime = { initAll, init, destroy(section) { instances.get(section)?.destroy(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true }); else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll(selector).forEach(section => instances.get(section)?.destroy()));
  document.addEventListener('shopify:block:select', event => {
    const scene = event.target.closest('[data-story-scene]');
    instances.get(event.target.closest(selector))?.focusScene(scene);
  });
})();
